import {DefinedFormFieldElement} from "@web-libs/core/forms/ui/fields/shared/form-field.types";
import {CSSProperties} from "react";
import {FormLayoutField} from "@web-libs/core/forms/ui/layout/form-layout-field";

export type FormLayoutRowProps = {
    row: DefinedFormFieldElement[]
    lastRow: boolean
}

export const FormLayoutRow = (props: FormLayoutRowProps) => {

    const rowStyles: CSSProperties = {
        display: "flex",
        flexDirection: "row",
        marginBottom: props.lastRow ? 32 : 16
    }

    const getFieldKey = (field: DefinedFormFieldElement) => field.props.name + "_inner"

    const renderRowItem = (field: DefinedFormFieldElement, index: number) => {
        return (
            <FormLayoutField key={getFieldKey(field)} field={field} index={index}/>
        )
    }

    return (
        <div style={rowStyles}>
            {props.row.map(renderRowItem)}
        </div>
    )
}
